import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment.local';
import { Country } from '../models';

@Injectable({ providedIn: 'root' })
export class CountryService {

    constructor(private http: HttpClient) { }

    get(): Observable<Country[]> {
        return this.http.get(environment.api.country).pipe(map((res: any) => res.data));
    }

}
